import { useTranslation } from 'react-i18next';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { STORY_PLATFORM_TYPES } from '../../../../../constants';
import { ICONS } from '../../../../../icons';

const usePlatformsData = () => {
  const { t } = useTranslation('story');

  const MAP_PLATFORMS_TO_LABELS = {
    [STORY_PLATFORM_TYPES.LINKEDIN]: 'LinkedIn',
    [STORY_PLATFORM_TYPES.YOUTUBE]: 'YouTube',
    [STORY_PLATFORM_TYPES.META]: 'Meta',
    [STORY_PLATFORM_TYPES.BANNERS]: t('banners'),
    [STORY_PLATFORM_TYPES.OTHER_SOCIALS]: t('otherSocials'),
    [STORY_PLATFORM_TYPES.LONG_FORM]: t('longForm'),
  };

  const MAPPED_PLATFORM_ICONS = {
    [STORY_PLATFORM_TYPES.LINKEDIN]: ICONS.LinkedInLogo,
    [STORY_PLATFORM_TYPES.YOUTUBE]: ICONS.YouTubeShortLogo,
    [STORY_PLATFORM_TYPES.META]: ICONS.MetaLogo,
    [STORY_PLATFORM_TYPES.BANNERS]: AspectRatioOutlinedIcon,
    [STORY_PLATFORM_TYPES.OTHER_SOCIALS]: HubOutlinedIcon,
    [STORY_PLATFORM_TYPES.LONG_FORM]: MailOutlineIcon,
  };

  const MAPPED_PLATFORM_ICON_COLORS = {
    [STORY_PLATFORM_TYPES.LINKEDIN]: '#0077B5',
    [STORY_PLATFORM_TYPES.YOUTUBE]: '#FF0000',
    [STORY_PLATFORM_TYPES.META]: '#1877F2',
    [STORY_PLATFORM_TYPES.BANNERS]: '#f97316',
    [STORY_PLATFORM_TYPES.OTHER_SOCIALS]: '#22c55e',
    [STORY_PLATFORM_TYPES.LONG_FORM]: '#eab308',
  };

  return { labels: MAP_PLATFORMS_TO_LABELS, icons: MAPPED_PLATFORM_ICONS, iconColors: MAPPED_PLATFORM_ICON_COLORS };
};

export default usePlatformsData;
